export const firstFieldsGroup = [
  {
    id: 2462,
    type: 'Fields::Label',
    order: 10,
    suborder: 1,
    code: 'field_2462',
    title: '**DATOS DEL SOLICITANTE O TITULAR DEL SERVICIO**',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2478,
    type: 'Fields::Text',
    order: 20,
    suborder: 1,
    code: 'field_2478',
    title: 'Apellidos/s:',
    description: '',
    required: true,
    required_message: '',
    key: 'apellido',
    placeholder: '',
    tooltip: '',
    format: "^[a-zA-Z'´áéíóúÁÉÍÓÚñÑ ]+$",
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2479,
    type: 'Fields::Text',
    order: 20,
    suborder: 2,
    code: 'field_2479',
    title: 'Nombre/s:',
    description: '',
    required: true,
    required_message: '',
    key: 'nombre',
    placeholder: '',
    tooltip: '',
    format: "^[a-zA-Z'´áéíóúÁÉÍÓÚñÑ ]+$",
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2480,
    type: 'Fields::Text',
    order: 30,
    suborder: 1,
    code: 'field_2480',
    title: 'Domicilio',
    description: '',
    required: true,
    required_message: '',
    key: 'domicilio',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2481,
    type: 'Fields::Text',
    order: 30,
    suborder: 2,
    code: 'field_2481',
    title: 'Nº del Servicio:',
    description: '',
    required: true,
    required_message: '',
    key: 'nro_servicio',
    placeholder: '',
    tooltip: '',
    format: '[0-9]',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2482,
    type: 'Fields::Date',
    order: 40,
    suborder: 1,
    code: 'field_2482',
    title: 'Fecha de Nacimiento:',
    description: '',
    required: true,
    required_message: '',
    key: 'fecha_nac',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2483,
    type: 'Fields::Text',
    order: 40,
    suborder: 2,
    code: 'field_2483',
    title: 'Nacionalidad',
    description: '',
    required: true,
    required_message: '',
    key: 'nacionalidad',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2484,
    type: 'Fields::Text',
    order: 50,
    suborder: 1,
    code: 'field_2484',
    title: 'DNI',
    description: '',
    required: true,
    required_message: '',
    key: 'DNI',
    placeholder: '',
    tooltip: '',
    format: '^([1-9]{1}[0-9]{6,7})$',
    format_error_message: 'Ingrese los dígitos de su DNI sin puntos',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2485,
    type: 'Fields::Text',
    order: 50,
    suborder: 2,
    code: 'field_2485',
    title: 'CUIL',
    description: '',
    required: true,
    required_message: '',
    key: 'CUIL',
    placeholder: '',
    tooltip: '',
    format: '^([0-9]{11})$',
    format_error_message: 'Ingrese el número de CUIL sin guiones',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2486,
    type: 'Fields::Phone',
    order: 60,
    suborder: 1,
    code: 'field_2486',
    title: 'Teléfono',
    description: '',
    required: true,
    required_message: '',
    key: 'telefono',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {
      area_code_label: 'Cod. área',
      area_code_placeholder: 'Sin 0'
    }
  },
  {
    id: 2487,
    type: 'Fields::Email',
    order: 70,
    suborder: 1,
    code: 'field_2487',
    title: 'Email',
    description: '',
    required: true,
    required_message: '',
    key: 'email',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2488,
    type: 'Fields::Label',
    order: 80,
    suborder: 1,
    code: 'field_2488',
    title: '**DATOS DE LOS MIEMBROS DEL GRUPO FAMILIAR CONVIVIENTE (INCLUYENDO EL TITULAR DEL SERVICIO)**',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2489,
    type: 'Fields::CustomTable',
    order: 90,
    suborder: 1,
    code: 'field_2488',
    description: '',
    required: false,
    required_message: '',
    key: 'grupo_familiar',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  }
];

export const secondFieldsGroup = [
  {
    id: 2528,
    type: 'Fields::Label',
    order: 300,
    suborder: 1,
    code: 'field_2528',
    title:
      '<b>CRITERIOS DE INCLUSIÓN:</b>1) Ingreso total por mes del grupo conviviente en base a parámetros de vulnerabilidad social a definir por SUSEPU; 2) Ser Titular de Programas Sociales, estar inscripto en el Régimen de Monotributo Social, ser Empleado/a de Servicios Domésticos (Ley 26.844); ser desocupado y estar percibiendo el seguro de desempleo. 3) Ser Titular de una Pensión Vitalicia a Veteranos de Guerra del Atlántico Sur; 4) Titular o integrante del grupo conviviente con Discapacidad acreditada mediante certificación expedida por el Ministerio de Salud de la Provincia.<br><b>CRITERIOS DE EXCLUSIÓN:</b>1) Que entre los miembros del grupo conviviente sean propietarios de más de un inmueble; 2) Que algún miembro del grupo conviviente sea propietario de un vehículo automotor cuyo modelo tenga hasta cinco (5) años de antigüedad. La SUSEPU podrá analizar casos especiales o excepcionales.<hr>',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2539,
    type: 'Fields::Label',
    order: 310,
    suborder: 1,
    code: 'field_2539',
    title: '**DOCUMENTACIÓN A PRESENTAR**',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2540,
    type: 'Fields::Attachment',
    order: 320,
    suborder: 1,
    code: 'field_2540',
    title: 'Fotocopia de última factura de energía eléctrica emitida.',
    description: '',
    required: true,
    required_message: '',
    key: 'facturaEnergia',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2542,
    type: 'Fields::Attachment',
    order: 340,
    suborder: 1,
    code: 'field_2542',
    title:
      'Si es  Pensionado, Beneficiario de una Pensión No Contributiva, o Titular de una Pensión Vitalicia a Veteranos de Guerra del Atlántico Sur , presentar Fotocopia de Recibo de Haberes o Pensión emitida por el empleador y/o ANSeS, respectivamente',
    description: '',
    required: false,
    required_message: '',
    key: 'relacionDependencia',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2544,
    type: 'Fields::Attachment',
    order: 360,
    suborder: 1,
    code: 'field_2544',
    title:
      'Si es empleado/a de Servicios Domésticos, fotocopia de comprobante de pago de aportes a la Seguridad Social, realizado por el empleador.',
    description: '',
    required: false,
    required_message: '',
    key: 'SeguridadSocial',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2546,
    type: 'Fields::Label',
    order: 380,
    suborder: 1,
    code: 'field_2546',
    title:
      'Si forman parte del grupo familiar conviviente y tienen otros ingresos, deberán cumplimentar con los requisitos 2, 3, 4, 5 y 6 precedentes. ',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2547,
    type: 'Fields::Label',
    order: 390,
    suborder: 1,
    code: 'field_2547',
    title:
      '<hr><i><b>La presente Solicitud de Tarifa Social Eléctrica reviste el carácter de Declaración Jurada y los datos consignados están sujetos a constatación y aprobación final por parte de la Superintendencia de Servicios Públicos y otras concesiones (SuSePu).</b></i><hr>',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2548,
    type: 'Fields::Label',
    order: 400,
    suborder: 1,
    code: 'field_2548',
    title: '**Sección 1: Datos básicos del Titular** ',
    description: '',
    required: false,
    required_message: '',
    key: 'label',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2549,
    type: 'Fields::Select',
    order: 410,
    suborder: 1,
    code: 'field_2549',
    title: '¿Posee Plan Social?',
    description: '',
    required: true,
    required_message: '',
    key: 'planSocial',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2049,
        field_id: 2549,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.720-03:00',
        updated_at: '2020-05-11T00:41:06.726-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2049',
        configuration: {}
      },
      {
        id: 2050,
        field_id: 2549,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.727-03:00',
        updated_at: '2020-05-11T00:41:06.732-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2050',
        configuration: {}
      }
    ]
  },
  {
    id: 2541,
    type: 'Fields::Attachment',
    order: 411,
    suborder: 1,
    code: 'field_2541',
    title:
      'Adjuntar documento que acredite tal situación y/o fotocopia del último recibo de percepción del subsidio.',
    description: '',
    required: true,
    required_message: '',
    key: 'programaSocial',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2549,
    visibility_parent_field_option_value_id: 2049,
    visibility_parent_field_option_values: [2049],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2550,
    type: 'Fields::Select',
    order: 420,
    suborder: 1,
    code: 'field_2550',
    title: 'Condición de Actividad ',
    description: '',
    required: true,
    required_message: '',
    key: 'condicionActividad',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2051,
        field_id: 2550,
        name: 'Desocupado',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.768-03:00',
        updated_at: '2020-05-11T00:41:06.773-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2051',
        configuration: {}
      },
      {
        id: 2052,
        field_id: 2550,
        name: 'Empleado',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.775-03:00',
        updated_at: '2020-05-11T00:41:06.779-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2052',
        configuration: {}
      },
      {
        id: 2053,
        field_id: 2550,
        name: 'Jubilado',
        order: 3,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.781-03:00',
        updated_at: '2020-05-11T00:41:06.786-03:00',
        parent_field_option_id: null,
        value: '3',
        code: 'field_option_2053',
        configuration: {}
      },
      {
        id: 2054,
        field_id: 2550,
        name: 'Cuentapropista',
        order: 4,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.788-03:00',
        updated_at: '2020-05-11T00:41:06.792-03:00',
        parent_field_option_id: null,
        value: '4',
        code: 'field_option_2054',
        configuration: {}
      },
      {
        id: 2055,
        field_id: 2550,
        name: 'Ama de Casa',
        order: 5,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.794-03:00',
        updated_at: '2020-05-11T00:41:06.799-03:00',
        parent_field_option_id: null,
        value: '5',
        code: 'field_option_2055',
        configuration: {}
      },
      {
        id: 2056,
        field_id: 2550,
        name: 'Estudiante',
        order: 6,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.800-03:00',
        updated_at: '2020-05-11T00:41:06.805-03:00',
        parent_field_option_id: null,
        value: '6',
        code: 'field_option_2056',
        configuration: {}
      }
    ]
  },
  {
    id: 2543,
    type: 'Fields::Attachment',
    order: 421,
    suborder: 1,
    code: 'field_2543',
    title:
      'Si está inscripto como Monotributista o Monotributista Social, comprobante de inscripción ante la AFIP.',
    description: '',
    required: false,
    required_message: '',
    key: 'comprobanteAFIP',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2550,
    visibility_parent_field_option_value_id: 2054,
    visibility_parent_field_option_values: [2054],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2557,
    type: 'Fields::Attachment',
    order: 422,
    suborder: 1,
    code: 'field_2557',
    title: 'Adjuntar seguro de desempleo',
    description: '',
    required: false,
    required_message: '',
    key: 'SeguroDesempleo',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2550,
    visibility_parent_field_option_value_id: 2051,
    visibility_parent_field_option_values: [2051],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2558,
    type: 'Fields::Attachment',
    order: 425,
    suborder: 1,
    code: 'field_2558',
    title: 'Fotocopia de recibo de haberes',
    description: '',
    required: true,
    required_message: '',
    key: 'HaberesEmpleado',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2550,
    visibility_parent_field_option_value_id: 2052,
    visibility_parent_field_option_values: [2052],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2559,
    type: 'Fields::Attachment',
    order: 426,
    suborder: 1,
    code: 'field_2559',
    title: 'Fotocopia de recibo de haberes',
    description: '',
    required: true,
    required_message: '',
    key: 'HaberesJubilado',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2550,
    visibility_parent_field_option_value_id: 2053,
    visibility_parent_field_option_values: [2053],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2551,
    type: 'Fields::Select',
    order: 430,
    suborder: 1,
    code: 'field_2551',
    title: 'Su trabajo principal es...',
    description: '',
    required: true,
    required_message: '',
    key: 'trabajoPrincipal',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2057,
        field_id: 2551,
        name: 'Permanente',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.838-03:00',
        updated_at: '2020-05-11T00:41:06.842-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2057',
        configuration: {}
      },
      {
        id: 2058,
        field_id: 2551,
        name: 'Temporario',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.844-03:00',
        updated_at: '2020-05-11T00:41:06.851-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2058',
        configuration: {}
      },
      {
        id: 2059,
        field_id: 2551,
        name: 'Changas',
        order: 3,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.853-03:00',
        updated_at: '2020-05-11T00:41:06.860-03:00',
        parent_field_option_id: null,
        value: '3',
        code: 'field_option_2059',
        configuration: {}
      },
      {
        id: 2060,
        field_id: 2551,
        name: 'Otro',
        order: 4,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.861-03:00',
        updated_at: '2020-05-11T00:41:06.881-03:00',
        parent_field_option_id: null,
        value: '4',
        code: 'field_option_2060',
        configuration: {}
      }
    ]
  },
  {
    id: 2552,
    type: 'Fields::Select',
    order: 440,
    suborder: 1,
    code: 'field_2552',
    title:
      '¿Es persona con discapacidad o tiene  Familiar con discapacidad viviendo con Usted? Aportar Certificado expedido por Ministerio de Salud de la Provincia',
    description: '',
    required: true,
    required_message: '',
    key: 'certificadoMinisterioDeSalud',
    placeholder:
      '¿Es persona con discapacidad o tiene  Familiar con discapacidad viviendo con Usted? Aportar Certificado expedido por Ministerio de Salud de la Provincia',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2061,
        field_id: 2552,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.908-03:00',
        updated_at: '2020-05-11T00:41:06.913-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2061',
        configuration: {}
      },
      {
        id: 2062,
        field_id: 2552,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:41:06.915-03:00',
        updated_at: '2020-05-11T00:41:06.920-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2062',
        configuration: {}
      }
    ]
  },
  {
    id: 2545,
    type: 'Fields::Attachment',
    order: 441,
    suborder: 1,
    code: 'field_2545',
    title: 'Acreditar mediante el CUD otorgado por Ministerio de Salud de la Provincia.',
    description: '',
    required: true,
    required_message: '',
    key: 'CUD',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: 2552,
    visibility_parent_field_option_value_id: 2061,
    visibility_parent_field_option_values: [2061],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {}
  },
  {
    id: 2553,
    type: 'Fields::Select',
    order: 450,
    suborder: 1,
    code: 'field_2553',
    title: '¿Tiene Gas Natural?',
    description: '',
    required: true,
    required_message: '',
    key: 'gasNatural',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2063,
        field_id: 2553,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:42:34.007-03:00',
        updated_at: '2020-05-11T00:42:34.012-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2063',
        configuration: {}
      },
      {
        id: 2064,
        field_id: 2553,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:42:34.014-03:00',
        updated_at: '2020-05-11T00:42:34.018-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2064',
        configuration: {}
      }
    ]
  },
  {
    id: 2554,
    type: 'Fields::Select',
    order: 460,
    suborder: 1,
    code: 'field_2554',
    title:
      '¿Utiliza algunas de las habitaciones de la vivienda exclusivamente como lugar de trabajo (consultorio, estudio, taller, negocio, etc.)?',
    description: '',
    required: true,
    required_message: '',
    key: 'viviendaTrabajo',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2065,
        field_id: 2554,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.663-03:00',
        updated_at: '2020-05-11T00:46:36.668-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2065',
        configuration: {}
      },
      {
        id: 2066,
        field_id: 2554,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.669-03:00',
        updated_at: '2020-05-11T00:46:36.674-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2066',
        configuration: {}
      }
    ]
  },
  {
    id: 2555,
    type: 'Fields::Select',
    order: 470,
    suborder: 1,
    code: 'field_2555',
    title:
      '¿Es usted o alguno de los miembros de su grupo conviviente titular registral de una propiedad inmueble?',
    description: '',
    required: true,
    required_message: '',
    key: 'propiedad',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2067,
        field_id: 2555,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.701-03:00',
        updated_at: '2020-05-11T00:46:36.709-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2067',
        configuration: {}
      },
      {
        id: 2068,
        field_id: 2555,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.712-03:00',
        updated_at: '2020-05-11T00:46:36.717-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2068',
        configuration: {}
      }
    ]
  },
  {
    id: 2556,
    type: 'Fields::Select',
    order: 480,
    suborder: 1,
    code: 'field_2556',
    title:
      '¿Es usted o algún miembro de su grupo  familiar conviviente titular registral de un vehículo automotor con modelo no mayor a cinco (5) años de antigüedad?',
    description: '',
    required: true,
    required_message: '',
    key: 'vehiculoAutomotor',
    placeholder: '',
    tooltip: '',
    format: '',
    format_error_message: '',
    form_id: 255,
    child_keys: '',
    visibility_parent_field_key_id: null,
    visibility_parent_field_option_value_id: null,
    visibility_parent_field_option_values: [],
    visibility_toggleable_field_id: null,
    visibility_toggleable_field_value: null,
    visibility_checkbox_field_id: null,
    visibility_checkbox_field_value: null,
    read_only: false,
    default_value: '',
    auxiliary: false,
    hidden: false,
    logic_evaluation: '',
    logic_evaluation_error_message: '',
    image_url: '',
    configuration: {},
    field_options: [
      {
        id: 2069,
        field_id: 2556,
        name: 'SI',
        order: 1,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.742-03:00',
        updated_at: '2020-05-11T00:46:36.746-03:00',
        parent_field_option_id: null,
        value: '1',
        code: 'field_option_2069',
        configuration: {}
      },
      {
        id: 2070,
        field_id: 2556,
        name: 'NO',
        order: 2,
        field_option_validation: '',
        created_at: '2020-05-11T00:46:36.748-03:00',
        updated_at: '2020-05-11T00:46:36.753-03:00',
        parent_field_option_id: null,
        value: '2',
        code: 'field_option_2070',
        configuration: {}
      }
    ]
  }
];
